import { weatherMachineChapters } from './content';
export const weatherMachineQuickReference = weatherMachineChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('QUICK REFERENCE'));
